import { JSX } from "react";
import { Redirect, Route, RouteComponentProps, Switch } from "react-router-dom";
import { NetworkSubmissionHome } from "@app/compliance-connect/network-submission/NetworkSubmissionHome";
import { NetworkSubmissionWizard } from "@app/compliance-connect/network-submission/NetworkSubmissionWizard";
import { NetworkProfilePage } from "@app/compliance-connect/issuer/network-profile/NetworkProfilePage";

const NetworkSubmissionRouter = (props: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route path={`${props.match.path}/view`} component={NetworkSubmissionHome} />
      <Redirect from={`${props.match.path}/create`} to={`${props.match.path}/create/0`} exact={true} />
      <Route path={`${props.match.path}/create/:step`} component={NetworkSubmissionWizard} />
      <Route path={`${props.match.path}/project/:submissionId`} component={NetworkProfilePage} />
      <Redirect from={props.match.path} to={`${props.match.path}/view`} exact={true} />
    </Switch>
  );
};

export default NetworkSubmissionRouter;